export { default, type FaqSectionProps, SECTION_ID as faqSectionId } from './FaqSection';
